"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var firestore_1 = require("firebase/firestore");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var ModalAlert_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalAlert"));
var StyledDropdownButton_1 = __importDefault(require("containers/TableMaker/components/StyledDropdownButton"));
var Divider_1 = __importDefault(require("shared/components/Divider"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var backend_1 = require("utils/backend");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var utils_1 = require("../NewConnection/utils");
var StatusDropdown = function (_a) {
    var iC = _a.item;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var isActive = (0, end2end_1.isIntConnActive)(iC);
    var _b = __read(react_1.default.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = __read(react_1.default.useState(''), 2), error = _c[0], setError = _c[1];
    var handleClick = function (event) { return setAnchorEl(anchorEl ? null : event.currentTarget); };
    var handleOnClose = function () { return setAnchorEl(null); };
    var _d = __read((0, hooks_1.useSubmitter)('integration_connections', iC.id), 1), changeTransaction = _d[0];
    var _e = __read((0, backend_1.useCall)('transactions-resyncConnectionCall', {
        // It resyncs 1 year only when the lastSync is not there, otherwise it resyncs since the lastSync
        connId: iC.id, companyId: iC.companyId, isResync: true, timeFrame: { years: 1, allowContinue: true },
    }, 200), 2), resyncConnection = _e[0], isLoadingTransactionsResyncCall = _e[1];
    var _f = __read((0, backend_1.useCall)('resync-resyncContacts', { connId: iC.id, companyId: iC.companyId }), 2), resyncContacts = _f[0], isLoadingContactsResyncCall = _f[1];
    var isLoadingResyncCall = isLoadingContactsResyncCall || isLoadingTransactionsResyncCall;
    var isFetching = iC.isFetchingTransactions || iC.isFetchingContacts;
    var isRechargeAf = iC.specialConnectionType === 'RECHARGE_AF';
    var callResync = function () {
        if (isRechargeAf) {
            return resyncContacts()();
        }
        return resyncConnection()();
    };
    var _g = __read((0, backend_1.useCall)('transactions-xero-userDisconnect', { connectionId: iC.id }), 2), disconnect = _g[0], isLoadingDisconnect = _g[1];
    var reconnect = function () {
        if (!iC.authorizeUriTemplate) {
            return;
        }
        (0, utils_1.redirectTowardsAuthUri)(iC.authorizeUriTemplate, "".concat(window.location.pathname, "?provider=").concat(iC.provider), iC.provider, iC.returnOrigin);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModalAlert_1.default, { open: !!error, onClose: function () { return setError(''); }, buttonAction: function () { return setError(''); }, status: "error", title: "Disconnection error", description: error }), (0, jsx_runtime_1.jsx)(StyledDropdownButton_1.default, __assign({ onClick: handleClick, isOpen: !!anchorEl, mr: -3.625 }, { children: (0, end2end_1.getIntConnStatus)(iC) })), (0, jsx_runtime_1.jsx)(DropdownMenu_1.default, __assign({ anchorEl: anchorEl, open: !!anchorEl, onClose: handleOnClose }, { children: isActive
                    ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Re-sync now", titleColor: "green", description: "We'll fetch all new ".concat(isRechargeAf ? 'contacts' : 'transactions', " since last sync"), onClick: callResync, disabled: isLoadingResyncCall || isFetching, autoFocus: true }), (0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Reconnect", onClick: reconnect, disabled: !iC.authorizeUriTemplate }), (0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Disconnect", description: "Remove connection, no new transactions will be fetched", disabled: isLoadingDisconnect || iC.provider !== 'Xero', onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    var disconnectResult;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, disconnect()()];
                                            case 1:
                                                disconnectResult = _a.sent();
                                                if (disconnectResult === null || disconnectResult === void 0 ? void 0 : disconnectResult.data.error) {
                                                    setError(disconnectResult === null || disconnectResult === void 0 ? void 0 : disconnectResult.data.error);
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, titleColor: "red" })] }))
                    : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Re-connect", description: "You'll need access to your accounting platform", titleColor: "green", disabled: !iC.authorizeUriTemplate, onClick: reconnect, autoFocus: true }), (0, end2end_1.userCan)(interfaces_1.ACCESS_LEVEL.Admin)(profile) && ((0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Remove", description: "Removes your inactive connection, no new transactions will be fetched.", titleColor: "red", onClick: function () { return changeTransaction({ deletedOn: firestore_1.Timestamp.now(), deleteReason: 'INACTIVE_USER_REMOVED' }); } }))] })) }))] }));
};
exports.default = StatusDropdown;
